<!--
 * @Descripttion: 备忘提醒 - 备忘事项列表页
 * @version:
 * @Author: geory
 * @Date: 2026-08-14 10:00:00
 * @LastEditors: geory
 * @LastEditTime: 2026-08-14 18:00:00
-->
<template>
    <div class="memoWrap">
        <div class="memoHeader">
            <div class="memoTitle">备忘事项<span class="memoCount">({{memoList.length}})</span></div>
            <div class="memoAddBtn" @click="openMemoEdit(null)">
                <span class="memoAddPlus">+</span>
                <span>新建备忘</span>
            </div>
        </div>
        <div class="memoScroll" :style="{'height':scrollHeight+'px'}">
            <!-- 待办列表 -->
            <div v-for="(item,idx) in todoList" :key="'memoTodo'+item.id"
                :class="['memoItem', item.isTop ? 'memoItemTop' : '']"
                @contextmenu.prevent.stop="showMenu($event,item)">
                <el-checkbox class="memoCheck" :value="item.isDone"
                    @change="(val)=>{toggleDone(item,val)}"></el-checkbox>
                <div class="memoBody">
                    <div class="memoText">{{item.content}}</div>
                    <div v-if="item.images && item.images.length" class="memoThumbs">
                        <img v-for="(img,imgIdx) in item.images" :key="'memoImg'+item.id+imgIdx" :src="img"
                            @click.stop="previewImage(item.images,imgIdx)" />
                    </div>
                    <div v-if="item.remindType != -1" class="memoRemind" @click.stop="openRemindDialog(item)">
                        <svg class="memoAlarmIcon" viewBox="0 0 24 24" width="13" height="13">
                            <path fill="currentColor"
                                d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
                        </svg>
                        <span>{{formatRemind(item)}}</span>
                    </div>
                </div>
                <div class="memoItemRight">
                    <span v-if="item.isTop" class="memoTopBadge">置顶</span>
                    <div class="memoSetRemind" @click.stop="setRemindClick(item)">设提醒</div>
                </div>
            </div>
            <!-- 空状态 -->
            <div v-if="!memoList.length && !loading" class="memoEmpty">暂无备忘，点击右上角“新建备忘”添加</div>
            <!-- 已完成分组（始终显示，无数据时计数为0） -->
            <div class="memoDoneGroup">
                <div class="memoDoneHeader" @click="doneShow = !doneShow">
                    <span class="memoDoneTitle">已完成({{doneList.length}})</span>
                    <svg class="memoDoneArrow" :class="{'memoDoneArrowFold':!doneShow}" viewBox="0 0 24 24" width="16"
                        height="16">
                        <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </div>
                <div v-show="doneShow">
                    <div v-if="!doneList.length" class="memoDoneEmpty">暂无已完成的备忘</div>
                    <div v-for="(item,idx) in doneList" :key="'memoDone'+item.id"
                        :class="['memoItem', 'memoItemDone', item.isTop ? 'memoItemTop' : '']"
                        @contextmenu.prevent.stop="showMenu($event,item)">
                        <el-checkbox class="memoCheck" :value="item.isDone"
                            @change="(val)=>{toggleDone(item,val)}"></el-checkbox>
                        <div class="memoBody">
                            <div class="memoText">{{item.content}}</div>
                            <div v-if="item.images && item.images.length" class="memoThumbs">
                                <img v-for="(img,imgIdx) in item.images" :key="'memoDoneImg'+item.id+imgIdx"
                                    :src="img" @click.stop="previewImage(item.images,imgIdx)" />
                            </div>
                            <div v-if="item.remindType != -1" class="memoRemind"
                                @click.stop="openRemindDialog(item)">
                                <svg class="memoAlarmIcon" viewBox="0 0 24 24" width="13" height="13">
                                    <path fill="currentColor"
                                        d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
                                </svg>
                                <span>{{formatRemind(item)}}</span>
                            </div>
                        </div>
                        <div class="memoItemRight">
                            <span v-if="item.isTop" class="memoTopBadge">置顶</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="memoLoading">加载中...</div>
        </div>

        <!-- 右键菜单 -->
        <right-menu v-show="menuShow" :menuY="menuPos[1]" :menuX="menuPos[0]" :cellList="menuCellList"
            @cellClick="menuCellClick" @hideMenu="menuShow = false"></right-menu>

        <!-- 设置提醒弹窗 -->
        <el-dialog title="设置提醒" :visible.sync="remindDialogShow" width="360px" custom-class="memoRemindDialog"
            :append-to-body="true" :close-on-click-modal="true">
            <memo-remind-setting v-model="remindValue"></memo-remind-setting>
            <div slot="footer" class="memoRemindDialogFooter">
                <el-button @click="remindDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="remindConfirm">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 图片预览 -->
        <div v-if="previewShow" class="memoPreviewMask" @click="closePreview">
            <div class="memoPreviewClose" title="关闭" @click.stop="closePreview">
                <svg viewBox="0 0 24 24" width="16" height="16">
                    <path fill="currentColor"
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
            </div>
            <img :src="previewUrl" :title="previewSending ? '发送中...' : '点击发送到吸附窗口'" @click.stop="sendPreviewImage" />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Checkbox,
        Dialog,
        Button
    } from 'element-ui';
    Vue.use(Checkbox)
    Vue.use(Dialog)
    Vue.use(Button)

    import rightMenu from '@/components/RightMenu'
    import memoRemindSetting from '@/components/MemoRemindSetting'
    import {
        buildMemoIcsFromItem,
        downloadMemoIcs
    } from '@/service/memoCalendarService'
    import {
        formatRemind,
        parseByWeekDay,
        getSyncCalendarDefault,
        isWindowsPlatform,
        setMemoListCache
    } from '@/service/memoRemindService'
    import {
        sendImageToChat
    } from '@/service/imageSendService'

    //完成状态存本机（服务端暂未提供状态字段）
    const DONE_KEY = "wminput:memo:done:local:v1";

    export default {
        name: "MemoList",
        props: {
            height: {
                type: Number,
                default: 400
            }
        },
        components: {
            rightMenu,
            memoRemindSetting
        },
        data() {
            return {
                memoList: [],
                loading: false,
                doneShow: true,
                doneMap: this.loadDoneMap(),
                menuShow: false,
                menuPos: [0, 0],
                menuData: null,
                menuCellList: [],
                remindDialogShow: false,
                remindItem: null,
                remindValue: {
                    remindType: -1,
                    notRepeatTime: 0,
                    byDayTime: 0,
                    byMonthDay: 1,
                    byWeekDay: [],
                    syncCalendar: getSyncCalendarDefault(),
                },
                previewShow: false,
                previewList: [],
                previewIdx: 0,
                previewSending: false,
            }
        },
        computed: {
            todoList() {
                return this.memoList.filter((item) => {
                    return !item.isDone
                })
            },
            doneList() {
                return this.memoList.filter((item) => {
                    return item.isDone
                })
            },
            scrollHeight() {
                return Math.max(this.height - 44, 100);
            },
            previewUrl() {
                if (!this.previewList.length) {
                    return ""
                }
                let idx = this.previewIdx;
                if (idx < 0) {
                    idx = 0;
                }
                if (idx >= this.previewList.length) {
                    idx = this.previewList.length - 1;
                }
                return this.previewList[idx];
            }
        },
        watch: {
            //预览打开时监听Esc关闭，关闭时移除监听
            previewShow(val) {
                if (val) {
                    this.bindPreviewKeyHandler();
                } else {
                    this.unbindPreviewKeyHandler();
                }
            }
        },
        methods: {
            formatRemind,
            //本地完成状态
            loadDoneMap() {
                try {
                    return JSON.parse(localStorage.getItem(DONE_KEY) || "{}");
                } catch (e) {
                    return {};
                }
            },
            saveDoneMap() {
                try {
                    localStorage.setItem(DONE_KEY, JSON.stringify(this.doneMap));
                } catch (e) {}
            },
            toggleDone(item, val) {
                item.isDone = !!val;
                this.$set(this.doneMap, String(item.id), !!val);
                this.saveDoneMap();
            },
            //数据归一化
            normalizeMemo(raw) {
                let media = [];
                if (raw.mediaArray) {
                    try {
                        media = JSON.parse(raw.mediaArray);
                    } catch (e) {
                        media = [];
                    }
                }
                if (!Array.isArray(media)) {
                    media = [];
                }
                const images = media.filter((m) => {
                    return m && m.type == 1 && m.url
                }).map((m) => {
                    return m.url
                })
                return {
                    id: raw.id,
                    content: raw.content != null ? raw.content : "",
                    remindType: raw.remindType != null ? Number(raw.remindType) : -1,
                    notRepeatTime: Number(raw.notRepeatTime) || 0,
                    byDayTime: Number(raw.byDayTime) || 0,
                    byMonthDay: Number(raw.byMonthDay) || 0,
                    byWeekDay: parseByWeekDay(raw.byWeekDay),
                    rawByWeekDay: raw.byWeekDay || "",
                    images: images,
                    rawMediaArray: raw.mediaArray || "",
                    isTop: raw.isTop == 1,
                    sortNum: Number(raw.sortNum) || 0,
                    isDone: !!this.doneMap[String(raw.id)],
                }
            },
            sortMemos() {
                this.memoList.sort((a, b) => {
                    const topDiff = (b.isTop ? 1 : 0) - (a.isTop ? 1 : 0);
                    if (topDiff) {
                        return topDiff;
                    }
                    return (b.sortNum || 0) - (a.sortNum || 0);
                });
            },
            async fetchMemoList() {
                this.loading = true;
                try {
                    let resp = await this.$http.memoQueryList({})
                    if (resp && resp.code == 200) {
                        let array = (resp.data && resp.data.array) || [];
                        this.memoList = array.map((val) => {
                            return this.normalizeMemo(val)
                        })
                        this.sortMemos();
                        //发布缓存：提醒调度器在「列表刷新」时更新，不轮询服务端
                        this.publishMemoListCache();
                    }
                } catch (e) {
                    console.log("fetchMemoList error:", e);
                }
                this.loading = false;
            },
            //发布备忘列表缓存并通知提醒调度器重新调度
            publishMemoListCache() {
                setMemoListCache(JSON.parse(JSON.stringify(this.memoList)));
                if (window.dispatchEvent) {
                    try {
                        window.dispatchEvent(new Event("memoListUpdated"));
                    } catch (e) {}
                }
            },
            refresh() {
                this.fetchMemoList();
            },
            //右键菜单
            showMenu(e, item) {
                this.menuPos = [e.x, e.y];
                this.menuData = item;
                this.menuCellList = [
                    { label: '编辑', action: 'edit' },
                    { label: item.isTop ? '取消置顶' : '置顶', action: item.isTop ? 'untop' : 'top' },
                    { label: '刷新', action: 'refresh' },
                    { label: '删除', action: 'del' },
                ];
                this.menuShow = true;
            },
            menuCellClick(idx) {
                const action = this.menuCellList[idx] && this.menuCellList[idx].action;
                if (action === 'edit') {
                    this.openMemoEdit(this.menuData);
                } else if (action === 'del') {
                    this.removeMemo();
                } else if (action === 'top') {
                    this.memoTop(3);
                } else if (action === 'untop') {
                    this.memoTop(4);
                } else if (action === 'refresh') {
                    this.memoTop(2);
                }
            },
            async removeMemo() {
                const item = this.menuData;
                if (!item) {
                    return;
                }
                try {
                    await this.$confirm('确定删除该备忘？', '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                } catch (e) {
                    return;
                }
                try {
                    let resp = await this.$http.memoOperate({
                        id: item.id,
                        type: 1,
                    })
                    if (resp && resp.code == 200) {
                        const idx = this.memoList.findIndex((v) => String(v.id) === String(item.id));
                        if (idx >= 0) {
                            this.memoList.splice(idx, 1);
                        }
                        this.$delete(this.doneMap, String(item.id));
                        this.saveDoneMap();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }
                } catch (e) {
                    console.log("memoOperate del error:", e);
                }
            },
            //置顶/取消置顶/刷新（刷到顶部）
            async memoTop(type) {
                const item = this.menuData;
                if (!item) {
                    return;
                }
                try {
                    let resp = await this.$http.memoOperate({
                        id: item.id,
                        type: type,
                    })
                    if (resp && resp.code == 200) {
                        this.refresh();
                    }
                } catch (e) {
                    console.log("memoOperate error:", e);
                }
            },
            openMemoEdit(item) {
                const memoData = item || null;
                if (this.$common.isElectron() && window.require) {
                    //Electron：打开独立编辑窗口
                    const {
                        ipcRenderer
                    } = window.require('electron');
                    ipcRenderer.send('openMemoEdit', JSON.stringify({
                        memoData: memoData,
                    }));
                } else {
                    //Web：跳转独立编辑页面
                    this.$router.push({
                        path: '/memoEdit',
                        query: memoData ? {
                            memoData: encodeURIComponent(JSON.stringify(memoData))
                        } : {},
                    });
                }
            },
            //设置提醒
            //点击「设提醒」：已设提醒的备忘直接同步到系统日历；未设提醒的先打开设置弹窗
            //Windows版停用系统日历同步：点击进入设置弹窗
            setRemindClick(item) {
                if (item.remindType != -1) {
                    if (isWindowsPlatform()) {
                        this.openRemindDialog(item);
                    } else {
                        this.syncToCalendar(item);
                    }
                } else {
                    this.openRemindDialog(item);
                }
            },
            openRemindDialog(item) {
                this.remindItem = item;
                this.remindValue = {
                    remindType: item.remindType != null ? item.remindType : -1,
                    notRepeatTime: item.notRepeatTime || 0,
                    byDayTime: item.byDayTime || 0,
                    byMonthDay: item.byMonthDay || 1,
                    byWeekDay: (item.byWeekDay || []).slice(),
                    syncCalendar: getSyncCalendarDefault(),
                };
                this.remindDialogShow = true;
            },
            async remindConfirm() {
                const item = this.remindItem;
                if (!item) {
                    return;
                }
                const remind = this.remindValue;
                if (remind.remindType === 0 && !remind.notRepeatTime) {
                    this.$message({
                        message: '请选择提醒时间',
                        type: 'warning'
                    });
                    return;
                }
                if (remind.remindType === 2 && !(remind.byWeekDay && remind.byWeekDay.length)) {
                    this.$message({
                        message: '请选择每周提醒的日期',
                        type: 'warning'
                    });
                    return;
                }
                let params = {
                    id: item.id,
                    content: item.content,
                    remindType: remind.remindType != null ? remind.remindType : -1,
                    notRepeatTime: remind.notRepeatTime || 0,
                    byDayTime: remind.byDayTime || 0,
                    byMonthDay: remind.byMonthDay || 0,
                    byWeekDay: remind.byWeekDay && remind.byWeekDay.length ? JSON.stringify(remind.byWeekDay) :
                        "",
                    mediaArray: item.rawMediaArray || "",
                };
                try {
                    let resp = await this.$http.memoSave(params)
                    if (resp && resp.code == 200) {
                        item.remindType = params.remindType;
                        item.notRepeatTime = params.notRepeatTime;
                        item.byDayTime = params.byDayTime;
                        item.byMonthDay = params.byMonthDay;
                        item.byWeekDay = parseByWeekDay(params.byWeekDay);
                        item.rawByWeekDay = params.byWeekDay;
                        this.remindDialogShow = false;
                        //提醒数据已变化：更新缓存并重新调度
                        this.publishMemoListCache();
                        //需要同步日历（Windows版停用系统日历同步，跳过）
                        if (remind.syncCalendar && params.remindType != -1 && !isWindowsPlatform()) {
                            this.syncToCalendar(item);
                        }
                    }
                } catch (e) {
                    console.log("memoSave remind error:", e);
                }
            },
            //同步备忘到系统日历（Windows版已停用：任何场景都不提示、不同步）
            syncToCalendar(item) {
                if (isWindowsPlatform()) {
                    return;
                }
                const ics = buildMemoIcsFromItem(item);
                if (!ics) {
                    return;
                }
                if (this.$common.isElectron() && window.require) {
                    //Electron模式：交给主进程写入/打开系统日历
                    const {
                        ipcRenderer
                    } = window.require('electron');
                    ipcRenderer.once('memoSyncCalendarResult', (e, res) => {
                        if (res && !res.ok && !res.silent) {
                            this.$message({
                                message: '静默写入系统日历失败，已改为打开日历文件导入；如弹出授权窗口请点击允许',
                                type: 'warning'
                            });
                        }
                    });
                    ipcRenderer.send('memoSyncCalendar', JSON.stringify({
                        memoId: item.id,
                        title: item.content,
                        //仅不重复类型走mac静默写入；重复类型由主进程打开ics导入
                        startTime: item.remindType === 0 ? this.remindDateStr(item.notRepeatTime) : "",
                        ics: ics,
                        //提醒配置（Windows端Outlook COM写入使用）
                        remind: {
                            remindType: item.remindType,
                            notRepeatTime: item.notRepeatTime || 0,
                            byDayTime: item.byDayTime || 0,
                            byMonthDay: item.byMonthDay || 0,
                            byWeekDay: item.byWeekDay || [],
                        },
                    }));
                } else {
                    //浏览器模式：下载ics文件，双击导入系统日历
                    downloadMemoIcs(item.content, ics);
                }
                this.$message({
                    message: '已同步到系统日历，如弹出确认窗口请点击确认',
                    type: 'success'
                });
            },
            remindDateStr(ms) {
                const d = new Date(Number(ms));
                if (isNaN(d.getTime())) {
                    return "";
                }
                const pad = (n) => n < 10 ? '0' + n : '' + n;
                return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d
                    .getHours()) + ':' + pad(d.getMinutes());
            },
            previewImage(list, idx) {
                this.previewList = list;
                this.previewIdx = idx;
                this.previewSending = false;
                this.previewShow = true;
            },
            closePreview() {
                this.previewShow = false;
                this.previewSending = false;
            },
            //点击预览大图：发送图片到吸附窗口（复用话术图片发送方法），发送成功后关闭预览
            async sendPreviewImage() {
                if (this.previewSending) {
                    return;
                }
                const imageUrl = this.previewUrl;
                if (!imageUrl) {
                    return;
                }
                this.previewSending = true;
                try {
                    const result = await sendImageToChat(imageUrl);
                    this.closePreview();
                    this.$message({
                        message: result.sent ? '图片已发送' : '图片已复制',
                        type: 'success'
                    });
                } catch (e) {
                    console.log("sendPreviewImage error:", e);
                    this.$message({
                        message: '图片发送失败',
                        type: 'error'
                    });
                    //发送失败保持预览打开，可再次点击重试
                    this.previewSending = false;
                }
            },
            //预览期间按Esc/←关闭
            bindPreviewKeyHandler() {
                if (this._previewKeyHandler) {
                    return;
                }
                this._previewKeyHandler = (e) => {
                    if (e.keyCode === 27 || e.key === 'Escape') {
                        this.closePreview();
                    }
                };
                document.addEventListener('keydown', this._previewKeyHandler);
            },
            unbindPreviewKeyHandler() {
                if (this._previewKeyHandler) {
                    document.removeEventListener('keydown', this._previewKeyHandler);
                    this._previewKeyHandler = null;
                }
            },
            //编辑窗口保存成功（主进程转发）→ 刷新列表
            bindMemoSavedEvent() {
                if (!(this.$common.isElectron() && window.require)) {
                    return;
                }
                const {
                    ipcRenderer
                } = window.require('electron');
                this._memoSavedHandler = () => {
                    this.refresh();
                };
                ipcRenderer.on('memoSaved', this._memoSavedHandler);
            },
            unbindMemoSavedEvent() {
                if (this._memoSavedHandler && window.require) {
                    try {
                        window.require('electron').ipcRenderer.removeListener('memoSaved', this
                            ._memoSavedHandler);
                    } catch (e) {}
                }
                this._memoSavedHandler = null;
            },
        },
        created() {
            //数据由父级在切换到备忘Tab时通过 refresh() 加载（每次切换都刷新）
            this.bindMemoSavedEvent();
        },
        beforeDestroy() {
            this.unbindPreviewKeyHandler();
            this.unbindMemoSavedEvent();
        },
    }
</script>

<style>
    /* 弹窗宽度在小面板下自适应 */
    .memoRemindDialog {
        max-width: 92vw;
    }

    /* 提醒时间日历面板(.memoTimePopper/.el-popper)的层级统一在 common/css/common.css
       里维护（必须高于弹窗遮罩 .v-modal），这里不要重复写 z-index：
       本文件的 CSS 是懒加载 chunk，晚于 common.css 注入，同权重会反过来盖掉全局规则。 */
</style>

<style scoped>
    .memoWrap {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
    }

    .memoHeader {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        border-bottom: 1px solid #F0F0F0;
        flex-shrink: 0;
    }

    .memoTitle {
        font-size: 16px;
        font-weight: bold;
        color: #3C3C3C;
    }

    .memoCount {
        font-size: 14px;
        font-weight: normal;
        color: #3C3C3C;
        margin-left: 2px;
    }

    .memoAddBtn {
        display: flex;
        align-items: center;
        background-color: #FB5D5C;
        color: #fff;
        font-size: 13px;
        height: 28px;
        padding: 0 12px;
        border-radius: 14px;
        cursor: pointer;
        user-select: none;
    }

    .memoAddBtn:hover {
        background-color: #f04a49;
    }

    .memoAddPlus {
        font-size: 16px;
        margin-right: 3px;
        line-height: 1;
    }

    .memoScroll {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .memoScroll::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .memoItem {
        display: flex;
        align-items: flex-start;
        padding: 10px 16px 10px 8px;
        border-bottom: 1px solid #E5E5E5;
    }

    .memoItemTop {
        background-color: #FFF9F9;
    }

    .memoCheck {
        margin-top: 1px;
        margin-right: 2px;
        flex-shrink: 0;
    }

    .memoCheck::v-deep .el-checkbox__inner {
        width: 16px;
        height: 16px;
        border-radius: 50%;
    }

    .memoCheck::v-deep .el-checkbox__inner::after {
        left: 5px;
        top: 2px;
    }

    .memoCheck::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #FB5D5C;
        border-color: #FB5D5C;
    }

    .memoCheck::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #FB5D5C;
    }

    .memoBody {
        flex: 1;
        min-width: 0;
        padding-left: 8px;
    }

    .memoText {
        font-size: 14px;
        color: #3C3C3C;
        line-height: 22px;
        white-space: pre-wrap;
        word-break: break-all;
        user-select: text;
    }

    .memoThumbs {
        display: flex;
        flex-wrap: wrap;
        margin-top: 6px;
    }

    .memoThumbs img {
        width: 56px;
        height: 56px;
        object-fit: cover;
        border-radius: 4px;
        margin-right: 8px;
        margin-bottom: 4px;
        cursor: pointer;
        background-color: #F5F6F6;
    }

    .memoRemind {
        display: flex;
        align-items: center;
        margin-top: 6px;
        cursor: pointer;
        color: #FB5D5C;
        font-size: 13px;
    }

    .memoAlarmIcon {
        margin-right: 4px;
        flex-shrink: 0;
    }

    .memoItemRight {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex-shrink: 0;
        margin-left: 8px;
        align-self: stretch;
    }

    .memoTopBadge {
        font-size: 11px;
        color: #FB5D5C;
        background-color: #FFE9E9;
        border-radius: 3px;
        padding: 0 4px;
        line-height: 16px;
        user-select: none;
        margin-bottom: 4px;
    }

    .memoSetRemind {
        color: #4A90E2;
        font-size: 13px;
        cursor: pointer;
        user-select: none;
        margin-top: auto;
        margin-bottom: 2px;
    }

    .memoSetRemind:hover {
        opacity: 0.8;
    }

    .memoEmpty {
        text-align: center;
        color: #999999;
        font-size: 14px;
        padding: 60px 0;
    }

    .memoLoading {
        text-align: center;
        color: #999999;
        font-size: 13px;
        padding: 12px 0;
    }

    /* 已完成分组 */
    .memoDoneGroup {
        margin-top: 0;
    }

    .memoDoneHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px;
        cursor: pointer;
        user-select: none;
        border-bottom: 1px solid #E5E5E5;
        background-color: #FAFAFA;
    }

    .memoDoneTitle {
        font-size: 14px;
        color: #999999;
    }

    .memoDoneEmpty {
        text-align: center;
        color: #CCCCCC;
        font-size: 13px;
        padding: 16px 0;
    }

    .memoDoneArrow {
        color: #BDBDBD;
        transition: transform 0.2s;
    }

    .memoDoneArrowFold {
        transform: rotate(-90deg);
    }

    /* 已完成条目置灰 + 贯穿横线 */
    .memoItemDone .memoText {
        color: #999999;
        text-decoration: line-through;
    }

    .memoItemDone .memoRemind {
        color: #BDBDBD;
        text-decoration: line-through;
    }

    .memoItemDone .memoThumbs img {
        filter: grayscale(60%);
    }

    .memoRemindDialogFooter {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    /* 图片预览 */
    .memoPreviewMask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.65);
        /* 需高于Electron顶部栏(99999)与备忘提醒横幅(99990)，否则右上角关闭按钮会被遮挡 */
        z-index: 99999999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .memoPreviewMask img {
        max-width: 90%;
        max-height: 90%;
        border-radius: 4px;
        cursor: pointer;
    }

    /* 图片预览关闭按钮 */
    .memoPreviewClose {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.45);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        z-index: 10;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
    }

    .memoPreviewClose:hover {
        background-color: rgba(251, 93, 92, 0.9);
    }
</style>
